/* eslint-disable */
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import history from 'routes/history';
import actionLoader from 'store/modules/loader/actions';
import { GET_ADMIN_LOGIN } from 'services/Admin';
import { LOGIN, LOGOUT, LOGIN_WITH_TOKEN } from 'services/Login';
import { appConst } from 'constants/appConstants';

const useAuth = () => {
  const dispatch = useDispatch();

  const [loaderShowing, setShowLoader] = useState(false);
  const [userData, setUserData] = useState({
    atualizarDados: false,
    jwtToken: null,
    userId: null,
    authenticated: false,
    nome: null,
    regionalId: null,
    siglaTipo: null,
  });

  useEffect(() => {
    async function autoLogin() {
      const loginUserData = JSON.parse(
        localStorage.getItem(appConst.STORAGE_NAME)
      );
      setUserData(loginUserData);
    }
    autoLogin();
  }, []);

  async function handleLogin({ username, password, redirect }) {
    showLoader(true);

    try {
      const res = await LOGIN({ username, password });
      const {
        value: {
          authenticated,
          nome,
          userId,
          regionalId,
          atualizarDados,
          error,
          siglaTipo,
        },
        jwtToken,
      } = res;

      localStorage.setItem(
        appConst.STORAGE_NAME,
        JSON.stringify({
          jwtToken: jwtToken,
          userId: userId,
          authenticated: authenticated,
          nome: nome,
          regionalId: regionalId,
          atualizarDados: atualizarDados,
          siglaTipo: siglaTipo,
        })
      );
      localStorage.setItem(appConst.TOKEN_NAME, res.jwtToken);
      setUserData({
        jwtToken: jwtToken,
        userId: userId,
        authenticated: authenticated,
        nome: nome,
        regionalId: regionalId,
        atualizarDados: atualizarDados,
        siglaTipo: siglaTipo,
      });
      showLoader(false);
      if (res.value.authenticated === true) {
        history.push(redirect);
      }
      return res.value;
    } catch (error) {
      showLoader(false);
      console.error('Erro no login:', error);

      const errorMessage =
        error.response?.data?.message ||
        'Erro ao fazer login. Tente novamente.';
      const errorDetails =
        error.response?.data?.errors || error.response?.data?.detail || null;

      // Se for erro 400, tenta extrair mais detalhes
      if (error.response?.status === 400) {
        const validationErrors = error.response?.data?.errors;
        if (validationErrors) {
          const errorList = Object.keys(validationErrors)
            .map(
              (key) =>
                `${key}: ${
                  Array.isArray(validationErrors[key])
                    ? validationErrors[key].join(', ')
                    : validationErrors[key]
                }`
            )
            .join('; ');

          return {
            authenticated: false,
            error: errorList || errorMessage,
            nome: null,
            userId: null,
            regionalId: null,
            atualizarDados: false,
            siglaTipo: null,
          };
        }
      }

      return {
        authenticated: false,
        error: errorDetails || errorMessage,
        nome: null,
        userId: null,
        regionalId: null,
        atualizarDados: false,
        siglaTipo: null,
      };
    }
  }

  async function handleLogout() {
    showLoader(true);
    await LOGOUT();
    localStorage.removeItem(appConst.STORAGE_NAME);
    localStorage.removeItem(appConst.TOKEN_NAME);
    setUserData({
      atualizarDados: false,
      jwtToken: null,
      userId: null,
      authenticated: false,
      nome: null,
      regionalId: null,
      siglaTipo: null,
    });
    history.replace('/login');
    showLoader(false);
  }

  async function adminLoginAs(usuarioId, redirect) {
    showLoader(true);

    let response = await GET_ADMIN_LOGIN(usuarioId);

    const {
      value: { authenticated, nome, userId, regionalId, atualizarDados, siglaTipo },
      jwtToken,
    } = response;

    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      siglaTipo,
    });

    showLoader(false);
    history.push(redirect || '/');
  }

  async function loginWithToken(token) {
    showLoader(true);
    const {
      value: {
        authenticated,
        nome,
        userId,
        regionalId,
        atualizarDados,
        urlRedirect,
        error,
        siglaTipo,
      },
      jwtToken,
    } = await LOGIN_WITH_TOKEN({ token: token });

    if (error?.length) {
      history.push('/');
      return;
    }

    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      siglaTipo,
    });

    history.push(urlRedirect || '/');
    showLoader(false);
  }

  function setLocalStorage(user) {
    localStorage.setItem(appConst.STORAGE_NAME, JSON.stringify(user));
    localStorage.setItem(appConst.TOKEN_NAME, user.jwtToken);
    setUserData(user);
  }

  async function showLoader(value) {
    dispatch(actionLoader.showLoader(value));
    setShowLoader(value);
  }

  return {
    loaderShowing,
    showLoader,
    handleLogin,
    handleLogout,
    userData,
    setUserData,
    adminLoginAs,
    loginWithToken,
  };
};

export default useAuth;
